import { login } from '../api/login.js';
import ChainApi from '../wallet/ChainApi';

const chainApi = ChainApi;

export async function connectWithLogin(addr, tokenAddr) {
  let address = null;
  
  let connectRes = false;
  try {
    connectRes = await chainApi.chainWeb3.connect('a');
  } catch (err) {
    connectRes = false;
    console.log('connect err:', err)
  }

  if(!connectRes) {
    return null;
  }

  let tempAddr = null;
  await chainApi.chainWeb3.web3.eth.getAccounts()
  .then(res => {
    if(res.length) {
      tempAddr = res[0];
    }
  })
  .catch(err => {
    console.log(err);
  });

  let tempCid = await chainApi.chainWeb3.web3.eth.getChainId();

  let incorrectChain = (process.env.VUE_APP_ENV == 'dev' ? (tempCid != 97) : (tempCid != 56));

  let switchRes = true;
  if(incorrectChain) {
    try{
      await chainApi.chainWeb3.web3.currentProvider.request({
        method: 'wallet_switchEthereumChain',
        params: [{ chainId: process.env.VUE_APP_ENV == 'dev' ? chainApi.chainWeb3.web3.utils.toHex(97) : chainApi.chainWeb3.web3.utils.toHex(56) }]
      });
      switchRes = true;
    }
    catch(err) {
      switchRes = false;
    }
    if(switchRes) {
      await new Promise(resolve => setTimeout(resolve, 300));
    }
  }
  else {
    switchRes = true;
  }

  if(tempAddr && switchRes) {
    tempCid = (process.env.VUE_APP_ENV == 'dev' ? 97 : 56);
    if(!sessionStorage.getItem('superAvatarAuthToken') || sessionStorage.getItem('superAvatarAccount') != tempAddr) {
      let dataToSign = "address=" + tempAddr + ",chain_id=" + tempCid;
      await chainApi.chainWeb3.web3.eth.personal.sign(dataToSign, tempAddr).then(async(sign)=>{
        let tempData = {
          address: tempAddr,
          chain_id: tempCid,
          sign: sign
        }

        await login(tempData)
        .then(async(res) => {
          let data = res.data;
          if(data.code == 0) {
            sessionStorage.setItem('superAvatarToken', data.data.access_token);
            sessionStorage.setItem('superAvatarAuthToken', data.data.header);
            sessionStorage.setItem('superAvatarAccount', tempAddr);

            address = tempAddr;
          }
        })
        .catch(err => {
          console.log(err);
        });
      })
      .catch(err => {
        console.log(err);
      })
    }
    else {
      address = tempAddr;
    }
    return address;
  }

  return null;
}
